import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar";
import { Divider, Paper, Typography,LinearProgress,Button, Grid,Link, Checkbox, TextField, TablePagination,Tooltip,IconButton, Drawer, fabClasses, Radio, Switch, Modal, MenuItem } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import AddIcon from '@mui/icons-material/Add';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DownloadIcon from  "@mui/icons-material/Download";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CloseIcon from '@mui/icons-material/Close';
import base_url from '../base.json'
import base from '../base.json'
import { ToastContainer, toast } from 'react-toastify';
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";


const drawerWidth = 80;

export class Users extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      is_side_close : false,
      name : "",
      email : "",
      phone : "",
      password :"",
      id :"",
      is_edit_open :false,
      is_delete_open :false,
      is_add_open : false,

//////////////////
     page: 0,
     rowsPerPage: 10,
     userList: [],
     Total_user_count: 0,


////////////// search fields data
   search_name: "",
   search_email: "",
   search_phone: "",





    }
    this.handleChange = this.handleChange.bind(this);
  }


  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };



  addUser = () => {
    if (
      this.state.name !== "" &&
      this.state.email !== "" &&
       this.state.phone!=="" &&
      this.state.password !== "" 
    ) {
      fetch(`${base_url.base_url}/admin/customer/addCustomer`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
          password: this.state.password,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if(result.status){

          this.setState(
            {
              name: "",
              email:"",
              phone: "",
              password:"",
              is_add_open:false,
            },()=>{
              this.instantRetrive();
              this.sucessfull('User registered')
            }
          );  
          }else{
            this.sucessfull('User already registered, user another email id')
          }
          
        });
    } else {
      this.sucessfull('Fill all fields')
    }
  };






componentDidMount(){
    /// retrive user list
fetch(
  `${base_url.base_url}/admin/customer/retriveCustomerList/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.search_name}/:${this.state.email}/:${this.state.phone}`,
  {
    method: "get",
  }
)
  .then((res) => {
    return res.json();
  })
  .then((result) => {
    this.setState({
      userList: result.data,
      Total_user_count: result.size,
    });
  });

  }


instantRetrive=()=>{
  fetch(
  `${base_url.base_url}/admin/customer/retriveCustomerList/:${this.state.page}/:${this.state.rowsPerPage}/:${this.state.search_name}/:${this.state.email}/:${this.state.phone}`,
  {
    method: "get",
  }
)
  .then((res) => {
    return res.json();
  })
  .then((result) => {
    this.setState({
      userList: result.data,
      Total_user_count: result.size,
    });
  });
}




handleSearchChange = (e) => {
  this.setState(
    {
      [e.target.name]: e.target.value,
    },
    () => {
      this.instantRetrive();
    }
  );
};



handleChangePage = (event, newPage) => {
  this.setState({ page: newPage }, () => {
    this.instantRetrive();
  });
};



handleChangeRowsPerPage = (event) => {
  this.setState(
    { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
    () => {
      this.instantRetrive();
    }
  );
};




  updateUserDetails = () => {
    if (
      this.state.name !== "" &&
      this.state.email !== "" &&
      this.state.phone!=="" &&
      this.state.password !== "" &&
      this.state.id!== ""
    ) {
      fetch(`${base_url.base_url}/admin/customer/updateCustomer`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "put",
        body: JSON.stringify({
          name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
          password: this.state.password,
          id: this.state.id
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
          if(result.status){

            this.setState(
            {
              name: "",
              email:"",
              phone: "",
              password:"",
              id:"",
              is_edit_open : false,
            },()=>{
              this.instantRetrive();
              this.sucessfull('User details updated')
            }
          );  
          }else{
            this.sucessfull('Email id exists. Use another email id')
          }
        
        });
    } else {
      this.sucessfull('Fill all fields')
    }
  };



  sucessfull=(data)=>{
    toast.success(data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      //transition: Bounce,
      });
  }

  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
<Box sx={{height:'100%',width:'100%'}}>


{
  /// header data
}
<Box  sx={{height:47,width:'100%',backgroundColor:'#fff',borderRadius:0,mt:0.2,borderBottom:0.5,borderBottomColor:'#dddddd' ,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
<Typography sx={{fontSize:16,ml:1}}>Customers</Typography>
<Box sx={{display:'flex',flexDirection:'row',mr:0.5,mt:0.5,mr:1}}>
<Button onClick={()=>this.setState({is_add_open:true})} variant="contained" disableElevation size="small" sx={{height:35,textTransform:'none'}} startIcon={<AddIcon />}>
  Add Customers
</Button>
</Box>
</Box>



{
  /// grid container
}
<Box sx={{paddingLeft:3,paddingRight:3,paddingTop:2}}>




<Paper elevation={0} sx={{backgroundColor:'#33abdf',}}>
<Typography sx={{fontWeight:'bold',fontSize:17,color:'#fff',ml:1,mt:1}}>Filter</Typography>
<Box sx={{ display: "flex", flexDirection: "row", mt: 1, mb: 2 ,m:1}}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ fontSize: 10, textTransform: "uppercase" ,color:'#fff' }}
                      >
                        First name
                      </Typography>
                      <TextField
                        placeholder="search first name"
                        InputProps={{ style: { fontSize: 12 } }}
                        size="small"
                        fullWidth
                        name="search_name"
                        value={this.state.search_name}
                        onChange={this.handleSearchChange}
                        sx={{ mr: 2, minWidth: 210, backgroundColor: "#fff",borderRadius:1 }}
                      />
                    </Box>
                  </Grid>
                </Grid>
</Box>
<br/>
</Paper>
  




<Box sx={{mt:2}}>
<Paper variant="outlined" sx={{minHeight:150,width:'100%'}}>
<TableContainer component={Box}> 
      <Table size="small" sx={{ minWidth: 950 }} aria-label="simple table">
        <TableHead sx={{backgroundColor:'#33abdf'}} >
          <TableRow>
          <TableCell align="left" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>ID</TableCell>
            <TableCell align="center" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>NAME</TableCell>
            <TableCell align="center" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>EMAIL</TableCell>
            <TableCell align="center" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>PHONE</TableCell>
            <TableCell align="center" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>PASSWORD</TableCell>
            <TableCell align="center" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>STATUS</TableCell>
            <TableCell align="right" sx={{fontSize:12,color:'#fff',fontFamily:'800'}}>ACTION</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {this.state.userList.map((row,index) => (
            <TableRow
              key={row._id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                backgroundColor: index % 2 ? "#f9f9f9" : "#fff",
              }}
            >
              <TableCell component="th"  align="left" scope="row">
                {index + 1}
              </TableCell>
              <TableCell align="center"><Typography sx={{fontSize:11,textTransform:'uppercase'}}>{row.name}</Typography></TableCell>
              <TableCell align="center"><Typography sx={{fontSize:11,textTransform:'uppercase'}}>{row.email}</Typography></TableCell>
              <TableCell align="center"><Typography sx={{fontSize:11,textTransform:'uppercase'}}>{row.phone}</Typography></TableCell>
              <TableCell align="center"><Typography sx={{fontSize:11,textTransform:'uppercase',}}>{row.password}</Typography></TableCell>
              <TableCell align="center"><Typography sx={{fontSize:11,textTransform:'uppercase'}}><Switch size="small" checked={true}/></Typography></TableCell>
              <TableCell align="right">   
              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "right",
                                }}
                              >
                                <Tooltip title="Edit">
                                  <IconButton size="small" onClick={() => {
 
                                   this.setState({
                                    is_edit_open :  true,
                                    id: row._id,
                                    name : row.name,
                                    email : row.email,
                                    phone : row.phone,
                                    password : row.password,
                                   })
                                  }}>
                                    <DriveFileRenameOutlineIcon
                                      sx={{
                                        color: "#8787c5",
                                        height: 15,
                                        width: 15,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Delete">
                                  <IconButton size="small" onClick={() => {
                        this.setState({
                          id: row._id,
                          is_delete_open : true
                        })
                                  }}>
                                    <DeleteForeverIcon
                                      sx={{
                                        color: "red",
                                        height: 15,
                                        width: 15,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>


                              </Box>
                   </TableCell>
            </TableRow>
          ))}
        </TableBody>
        </Table>
      </TableContainer>
      <Divider/>
      <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.Total_user_count}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />

</Paper>
</Box>












{
  /// user data addition and update
}

   <Box>
          <Modal
            open={this.state.is_add_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "90vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_add_open: false,
                        name: "",
                        password:"",
                        email : "",
                        phone : '',
                        id:""
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Add Customers Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Users Name
                            </Typography>

  
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Users Name"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="name"
                              value={this.state.name}
                              onChange={this.handleChange}
                            />
                          
                              <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Phone
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="phone"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="phone"
                              value={this.state.phone}
                              onChange={this.handleChange}
                            />
                         
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Email
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Email"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                            />
                          

                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Password
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Password"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="password"
                              value={this.state.password}
                              onChange={this.handleChange}
                            />
                         

                    <br />
                    <br/>

                    <Button
                    variant="contained"
                    size="small"
                    sx={{textTransform:'none',fontSize:12}}
                      onClick={this.addUser}
                    >
                      Add Customers Details
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
   </Box>
 

   <Box>
          <Modal
            open={this.state.is_edit_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "90vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_open: false,
                        name: "",
                        password:"",
                        email : "",
                        phone : ''
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Customers Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >


                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Users Name
                            </Typography>

  
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Users Name"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="name"
                              value={this.state.name}
                              onChange={this.handleChange}
                            />
                          
                              <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Phone
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="phone"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="phone"
                              value={this.state.phone}
                              onChange={this.handleChange}
                            />
                         
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Email
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Email"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                            />
                          

                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                                mt:2
                              }}
                            >
                              Password
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Password"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="password"
                              value={this.state.password}
                              onChange={this.handleChange}
                            />

                    <br />

                    <Button
                      onClick={this.updateUserDetails}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Customers
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
   </Box>


   <Box>
          <Modal
            open={this.state.is_delete_open}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_delete_open: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(`${base.base_url}/admin/customer/deleteUsers`, {
                          headers: {
                            "content-type": "application/json",
                          },
                          method: "delete",
                          body: JSON.stringify({
                            _id: this.state.id,
                          }),
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              id: "",
                              is_delete_open : false,
                            });
                            this.instantRetrive();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
   </Box>










</Box>
</Box>
        </Box>




  <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
//transition={Bounce}
/>


      </Box>
    );
  }
}

export default Users;



